import type { IteroAssetType } from '../../../../../services/iteroBrowse';

const INLINE_STAGE_CLASS = 'h-[230px] rounded-lg bg-[#eef1f4]';
const FULLSCREEN_STAGE_CLASS = 'min-h-0 flex-1 rounded-lg bg-[#eef1f4]';

const INLINE_THUMB_SIZE_CLASS = 'h-11 w-14';
const FULLSCREEN_THUMB_SIZE_CLASS = 'h-14 w-[72px]';

export function galleryStageClass(fullscreen: boolean): string {
    return fullscreen ? FULLSCREEN_STAGE_CLASS : INLINE_STAGE_CLASS;
}

export function galleryThumbSizeClass(fullscreen: boolean): string {
    return fullscreen ? FULLSCREEN_THUMB_SIZE_CLASS : INLINE_THUMB_SIZE_CLASS;
}

export type ScanImageTabId = 'model-views' | 'screen-captures';
export type ScanImageAssetType = Extract<IteroAssetType, 'IMAGE_GALLERY' | 'SCREEN_CAPTURE'>;

export interface ScanImageTab {
    id: ScanImageTabId;
    label: string;
    assetType: ScanImageAssetType;
    imageNoun: string;
    emptyText: string;
    generatingText: string;
    errorText: string;
}

export const SCAN_IMAGE_TABS: readonly ScanImageTab[] = [
    {
        id: 'model-views',
        label: 'Model views',
        assetType: 'IMAGE_GALLERY',
        imageNoun: 'Model view',
        emptyText: 'No model views',
        generatingText: 'Preparing the images. Try again in about a minute.',
        errorText: "Couldn't load the images"
    },
    {
        id: 'screen-captures',
        label: 'Screen captures',
        assetType: 'SCREEN_CAPTURE',
        imageNoun: 'Screen capture',
        emptyText: 'No screen captures',
        generatingText: 'Preparing the images. Try again in about a minute.',
        errorText: "Couldn't load the screen captures"
    }
];

export function scanImageTab(id: ScanImageTabId): ScanImageTab {
    return SCAN_IMAGE_TABS.find((tab) => tab.id === id) ?? SCAN_IMAGE_TABS[0];
}

export function nextScanImageTab(current: ScanImageTabId, step: 1 | -1): ScanImageTabId {
    const index = SCAN_IMAGE_TABS.findIndex((tab) => tab.id === current);
    const count = SCAN_IMAGE_TABS.length;
    return SCAN_IMAGE_TABS[(index + step + count) % count].id;
}
